import { message } from 'antd'
import { useGetCertificateStatusQuery, useLazyGetLearnWorldsLoginLinkQuery } from 'api/learn-worlds-api'

export const useCpdLogin = (skipStatusCheck?: true) => {
  const [getLink, { isFetching }] = useLazyGetLearnWorldsLoginLinkQuery()
  const { data: cpdStatus, isLoading: isStatusLoading } = useGetCertificateStatusQuery(undefined, {
    skip: skipStatusCheck === true
  })

  const login = async () => {
    try {
      const { loginLink } = await getLink().unwrap()
      window.open(loginLink, '_blank', 'noopener,noreferrer')
    } catch {
      message.error('Failed to generate CPD login link. Please try again.')
    }
  }

  return {
    login,
    isFetching,
    cpdStatus,
    isStatusLoading
  }
}
